<template>
  <div class="container">
    <form-locale />
    <form class="needs-validation" id="form" @keydown.enter.prevent="nextInput" novalidate>
      <contract-details />
      <parties />
      <product-and-area />
      <supplier-rights />
      <distributor-rights />
      <duration-and-resignation />
      <goodwill />
      <other-regulations />
      <venue-governing-law />
      <signature />
    </form>
  </div>
</template>

<script>
import FormLocale from "./FormLocale.vue";
import ContractDetails from "./ContractDetails.vue";
import Parties from "./parties/PartiesInput";
import ProductAndArea from "./ProductsAndAreaInput";
import SupplierRights from "./SupplierRightsAndObligationsInput.vue";
import DistributorRights from "./DistributorRightsAndObligationsInput.vue";
import DurationAndResignation from "./DurationAndResignation.vue";
import Goodwill from "./GoodwillInput.vue";
import OtherRegulations from "./OtherRegulationsInput.vue";
import VenueGoverningLaw from "./VenueGoverningLawInput";
import Signature from "./SignatureInput";

export default {
  components: {
    FormLocale,
    ContractDetails,
    Parties,
    ProductAndArea,
    SupplierRights,
    DistributorRights,
    DurationAndResignation,
    Goodwill,
    OtherRegulations,
    VenueGoverningLaw,
    Signature
  },
  methods: {
    nextInput(event) {
      let inputs = $("input, select, textarea");
      let index = inputs.index(event.target) + 1;
      inputs.eq(index).focus();
    }
  }
};
</script>

<style>
fieldset {
  margin-bottom: 1rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid black;
}

legend {
  margin-bottom: 0;
  font-size: 1.3rem;
}

/* Overwrite bootstraps form-control styling. Needed because we use the form-control class to trigger error messages. */

.form-control {
  box-sizing: border-box;
  -webkit-appearance: none;
  width: 100%;
  background: #fff;
  border: 2px solid #2a18cc;
  border-radius: 0;
  font-size: 1.05rem;
  line-height: 1.5rem;
  color: #313841;
}

.form-control.datepicker {
  background-color: #fff;
}

.form-control textarea {
  width: 100%;
}

.form-group.no-label {
  margin-top: 2rem;
}

.input-group-text {
  color: #fff;
  font-weight: 500;
  background-color: #2a18cc;
  border: 2px solid #2a18cc;
}

.input-group-text.clickable-addon:hover {
  background-color: #1cd6ac;
  border: 2px solid #1cd6ac;
  cursor: pointer;
}

input[type="checkbox"]:focus,
input[type="radio"]:focus {
  border-color: #80bdff;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

input[type="checkbox"]:disabled,
label.disabled {
  opacity: 0.5;
}

#select_agreement option:last-child {
  font-weight: 500;
}

.fa.fa-angle-down,
.fa.fa-angle-up {
  position: relative;
  top: 3px;
  font-size: 1.5rem;
  margin-right: 1rem;
}

a[aria-expanded="true"] .fa.fa-angle-down {
  display: none;
}

a[aria-expanded="false"] .fa.fa-angle-up {
  display: none;
}

.fa.fa-plus-square {
  font-size: 1rem;
  margin-left: 0.5rem;
}

.fa.fa-question-circle {
  margin-left: 0.5rem;
}

a.fa.fa-question-circle,
a.fa.fa-plus-square,
a.fa.fa-plus-circle {
  color: #2a18cc;
}

a.fa.fa-question-circle:hover,
a.fa.fa-plus-square:hover,
a.fa.fa-plus-circle:hover {
  color: #1cd6ac;
  cursor: pointer;
}

a.fa.icon-inline {
  color: #2a18cc;
  position: relative;
  top: 15px;
}

.inline > div {
  display: inline-block;
  width: 45%;
}

/* Remove green borders from valid input fields when validating */

.custom-select.is-valid,
.form-control.is-valid,
.was-validated .custom-select:valid,
.was-validated .form-control:valid {
  border-color: #2a18cc;
}

/* Remove green text from check marks */

.form-check-input.is-valid ~ .form-check-label,
.was-validated .form-check-input:valid ~ .form-check-label {
  color: #313841;
}

/* Invalid input field styling from DE website */

.custom-select.is-invalid,
.form-control.is-invalid,
.was-validated .custom-select:invalid,
.was-validated .form-control:invalid {
  background-color: #ffedeb;
  border-color: #ff4935;
}

.invalid-feedback {
  margin-top: 0;
}

/* Error message styling from DE website */

.invalid-feedback span {
  position: absolute;
  bottom: -25px;
  right: 0px;
  text-align: right;
  color: #ff4935;
  font-size: 14.5px;
  font-weight: 500;
  margin-top: 0;
  min-height: 17px;
}

.label-notice {
  margin-left: 5px;
  font-size: 0.8rem;
  font-style: italic;
}

.translation-links > ul {
  margin: 0 0 1rem 0;
}

.clickable-text:hover,
.clickable-text:hover > a.fa.fa-plus-square {
  color: #1cd6ac;
  cursor: pointer;
}

.vdp-datepicker {
  width: 100%;
}

.vdp-datepicker__calendar .cell.selected,
.vdp-datepicker__calendar .cell.selected:hover {
  background: #2a18cc !important;
  color: #fff !important;
}

.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day:hover,
.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).month:hover,
.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).year:hover {
  border: 1px solid #2a18cc !important;
}
</style>



// WEBPACK FOOTER //
// src/apps/eneforhandler/components/form/Form.vue